const STORAGE_KEY = 'sheep_manager_currency';

// Supported currencies. `locale` drives digit grouping via toLocaleString.
export const CURRENCIES = {
  KES: { code: 'KES', label: 'Kenyan Shilling', locale: 'en-KE' },
  USD: { code: 'USD', label: 'US Dollar', locale: 'en-US' },
  EUR: { code: 'EUR', label: 'Euro', locale: 'en-IE' },
  GBP: { code: 'GBP', label: 'British Pound', locale: 'en-GB' },
  ZAR: { code: 'ZAR', label: 'South African Rand', locale: 'en-ZA' },
  NGN: { code: 'NGN', label: 'Nigerian Naira', locale: 'en-NG' },
  AUD: { code: 'AUD', label: 'Australian Dollar', locale: 'en-AU' },
};

const DEFAULT_CODE = 'KES';

let current = (() => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored && CURRENCIES[stored] ? stored : DEFAULT_CODE;
  } catch {
    return DEFAULT_CODE;
  }
})();

const listeners = new Set();

export function currencyCode() {
  return current;
}

export function setCurrency(code) {
  if (!CURRENCIES[code]) return;
  current = code;
  try { localStorage.setItem(STORAGE_KEY, code); } catch { /* ignore */ }
  listeners.forEach(fn => fn(code));
}

// Subscribe to currency changes; returns an unsubscribe function.
export function onCurrencyChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function formatMoney(value, options = {}) {
  const numeric = Number(value || 0);
  const { locale, code } = CURRENCIES[current] || CURRENCIES[DEFAULT_CODE];
  const amount = Math.abs(numeric).toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const sign = numeric < 0 ? '-' : options.showPositiveSign && numeric > 0 ? '+' : '';
  return `${sign}${code} ${amount}`;
}
